<template>
  <div class="hang-up-button" title="Disconnect">
    <span v-if="call.contact">{{call.contact.name}}</span>
    <div class="call-duration">{{callDurationDisplay}}</div>
    <div class="btn">
      <div class="Phone" :class="{'is-animating': hangUpLoading}"></div>
<!--      <img src="../../assets/icon_call_end.svg">-->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HangUpButton',
    props: {
      call: {
        type: Object
      },
      hangUpLoading: {
        type: Boolean
      }
    },
    computed: {
      callDurationDisplay() {
        let minutes = Math.floor(this.call.duration / 60);
        let seconds = this.call.duration - minutes * 60;

        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      },
    }
  }
</script>

<style lang="scss">
@import "HangUpButton";
</style>
